var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("p", [_vm._v(_vm._s(_vm.$t("嵌套菜单")) + "1 "), _c("a-rate", {
    staticStyle: {
      "margin-left": "10px"
    },
    model: {
      value: _vm.value,
      callback: function ($$v) {
        _vm.value = $$v;
      },
      expression: "value"
    }
  })], 1), _c("router-view")], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };